<template>
  <autocomplete-multiple
      name="Теги"
      :items="items"
      :select.sync="localSelect"
      :loading="state.isLoading"
      inline
  >
    <template v-slot:customInfo="{item}">
      <chip class="mr-2" :color="item.color"><span :style="`color:${$tools.getContrastColor(item.color)}`">{{item.name}}</span></chip>
    </template>
    <template v-slot:selectedInfo="{item}">
      <chip class="mr-2" :color="item.color"><span :style="`color:${$tools.getContrastColor(item.color)}`">{{item.name}}</span></chip>
    </template>
  </autocomplete-multiple>
</template>

<script>
import State from "@/plugins/state";
import AutocompleteMultiple from "@/componentsV2/base/AutocompleteMultiple.vue";
import Chip from "../../componentsV2/base/Chip.vue";

import {
  Entity_Tag,
} from "../../../EntityStoreCacheService";

export default {
  components: {AutocompleteMultiple,Chip},
  props:['select', 'entityType'],
  data:()=>({
    localSelect: null,
    state: new State(),
    items:[]
  }),
  mounted() {
    this.localSelect = this.select;
    let rb = new Entity_Tag()
        .selects(Entity_Tag.id)
        .selects(Entity_Tag.name)
        .selects(Entity_Tag.color)
        if (this.entityType!==undefined)
          rb.filterAnd([Entity_Tag.entity, Entity_Tag.type].join('.')+'=?',this.entityType)

        rb.order(Entity_Tag.name, true)
        .page(1).onPage(1000)
        .addStateCallback((v)=> this.state.setRequestBuilderState(v))
        .addStateCallback((v)=>{
          if(v.success)
            this.items = v.items;
        })
        .request()
  },
  watch: {
    select() {
      this.localSelect = this.select;
    },
    localSelect() {
      this.$emit('update:select', this.localSelect)
    },
  }
}
</script>